import { capitalize } from '../helpers/common';

import { BLANK_FILTER_TEXT } from '../constants/livestock';

export const sortStrings = (a, b) => {
  const strA = !a ? '' : a + '';
  const strB = !b ? '' : b + '';

  return strA.localeCompare(strB);
};

export const sortDates = (a, b) => {
  if (a === null || a === undefined) return 1;
  if (b === null || b === undefined) return -1;

  const dateA = new Date(a);
  const dateB = new Date(b);
  const isValidA = !isNaN(dateA.getTime());
  const isValidB = !isNaN(dateB.getTime());

  if (!isValidA && !isValidB) return 0;
  if (!isValidA) return 1;
  if (!isValidB) return -1;

  return dateA - dateB;
};

export const sortNumbers = (a, b) => {
  const numA = parseFloat(a);
  const numB = parseFloat(b);

  const isNumA = !isNaN(numA);
  const isNumB = !isNaN(numB);

  if (!isNumA && !isNumB) return 0;
  if (!isNumA) return 1;
  if (!isNumB) return -1;

  return numA - numB;
};

export const getFilterOptions = (sourceData, field, field1) => {
  if (!Array.isArray(sourceData) || !field) return [];

  const seen = new Set();
  const results = [];
  const dataLength = sourceData.length;

  for (let i = 0; i < dataLength; i++) {
    const entry = sourceData[i];
    let value = entry?.[field];

    if (field1 && value) {
      value = value[field1];
    }

    const displayValue = value || BLANK_FILTER_TEXT;
    const displayValueInLowerCase = displayValue.toLowerCase();

    if (!seen.has(displayValueInLowerCase)) {
      seen.add(displayValueInLowerCase);
      results.push({ text: capitalize(displayValueInLowerCase), value: displayValue });
    }
  }

  return results;
};
